import Layout from '@adv-mt/mt-layout-basic'
import {PanelBasic} from '@adv-mt/mt-panel-basic'

import LinkFactory from '../../components/LinkFactory/index.js'

const Skeleton = () => (
  <Layout.Basic isPaddingless linkFactory={LinkFactory}>
    <PanelBasic>
      <div className="mt-Static" />
    </PanelBasic>
  </Layout.Basic>
)

export default Skeleton
